<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>
  @let formGroup = $formGroup();
  <ng-container actions>
    <unity-action-shared [action]="$cloneFormTemplateAction()" />
    <unity-workflow-selector-shared
      [transitions]="$availableTransitions()"
      [disabled]="$workflowActionsDisabled()"
      (workflowEvent)="onWorkflow($event)" />
  </ng-container>

  <unity-panel-manage-shared
    [resource]="$resource()"
    [resourceName]="resourceName"
    [formGroup]="formGroup"
    [isEditable]="$isEntitledToEdit()"
    [submitLoading]="$updateLoading()"
    (saveEvent)="onSave()"
    (detailEditEvent)="toggleWorkflowActions($event)">
    <unity-form-layout>
      <unity-textbox-control displayName="Name" description="Provide a name." [control]="formGroup.controls.name" />
      <unity-textarea-control displayName="Description" description="Provide a description." [control]="formGroup.controls.description" />
      <unity-dropdown-workflow-control
        displayName="Workflow"
        description="Select the workflow used for this form."
        [control]="formGroup.controls.default_workflow_id" />
      <unity-survey-creator-control
        displayName="Form Creator"
        description="Click to launch the form creator and start designing the form."
        [control]="formGroup.controls.data" />
    </unity-form-layout>
  </unity-panel-manage-shared>
</unity-page-container>
